<div
  [className]="commonService.chatExist ? 'app-container' : 'app-container-wo'"
>
  <div class="content-container">
    <div class="row m-0">
      <div class="col-md-2 p-0"></div>
      <div class="col-sm-12 col-md-3 pe-5 ps-0" style="padding: 0px 25px">
        <div class="">
          <div class="app-heading">{{ "safetyPlan.title" | translate }}</div>
          <div class="app-content-body">
            {{ "safetyPlan.mainContent" | translate }}
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-5 p-0 position-relative">
        <div class="content-container-frame">
          <div
            [ngClass]="{
              'safety-plan-container-overflow': commonService.chatExist,
              'safety-plan-container-overflow-wo': !commonService.chatExist
            }"
          >
            <div
              id="slider"
              class="carousel slide p-0"
              data-bs-ride="false"
              data-bs-interval="false"
              data-bs-wrap="false"
              data-bs-touch="false"
            >
              <div class="carousel-inner">
                <div
                  class="app-sub-heading carousel-item"
                  [ngClass]="{ active: currentSlide === 1 }"
                >
                  <div
                    *ngFor="let safetyPlan of safetyPlanList; let i = index"
                    [ngClass]="{ 'border-0': i == safetyPlanList.length - 1 }"
                    (click)="viewSafetyPlan(i)"
                  >
                    {{ safetyPlan.header | translate }}
                  </div>
                  <div class="px-5 border-0">
                    <button
                      mat-button
                      class="secondary-button w-100 bg-white"
                      (click)="downloadSafetyPlan()"
                    >
                      <mat-spinner
                        [diameter]="25"
                        *ngIf="isDownloading"
                      ></mat-spinner>
                      {{ "safetyPlan.downloadBtn" | translate }}
                    </button>
                  </div>
                </div>
                <div
                  class="carousel-item"
                  [ngClass]="{ active: currentSlide === 2 }"
                >
                  <div class="app-sub-heading" style="padding: 25px 25px 0px">
                    <div
                      class="d-flex align-items-center w-100 border-0"
                      style="padding: 1rem 0rem"
                    >
                      <img
                        [src]="commonService.resource.image.left_arrow"
                        alt=""
                        [ngClass]="{ 'd-none': currentSafetyPlanIndex < 1 }"
                        (click)="nextSafetyPlan(-1)"
                      />
                      <span
                        class="d-flex w-100 align-items-center justify-content-center"
                      >
                        <span>
                          {{
                            safetyPlanList[currentSafetyPlanIndex]["header"]
                              | translate
                          }}
                        </span>
                        <span
                          class="material-icons-outlined font-16 px-2"
                          style="padding-bottom: 0.4px"
                          (click)="currentSlide = 1"
                        >
                          menu
                        </span>
                      </span>
                      <img
                        [src]="commonService.resource.image.right_arrow"
                        alt=""
                        (click)="nextSafetyPlan(1)"
                        *ngIf="
                          currentSafetyPlanIndex < safetyPlanList.length - 1
                        "
                      />
                    </div>
                  </div>
                  <div class="">
                    <div
                      class="safety-plan-content bg-white p-4"
                      (click)="showSafetyPlanEdit(3)"
                      style="cursor: pointer"
                    >
                      <p
                        class="clickable-paragraph"
                        style="min-height: calc(var(--vh, 1vh) - 400px)"
                      >
                        {{
                          safetyPlanList[currentSafetyPlanIndex]["content"]
                            | translate
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-2 p-0"></div>
    </div>
  </div>
</div>

<!-- Modal -->
<div
  mdbModal
  #safetyPlanModal="mdb-modal"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="false"
  [config]="{ keyboard: false, ignoreBackdropClick: true }"
>
  <div [innerHTML]="commonService.getModalBackgroundImg('#EBFAEE')"></div>
  <div class="row m-0">
    <div class="col-md-2 p-0"></div>
    <div class="col-md-3 col-sm-12 p-0"></div>
    <div class="col-md-5 col-sm-12 p-0">
      <div class="modal-dialog chat-modal-dialog">
        <div class="modal-content">
          <div class="modal-body p-0 d-flex flex-column">
            <div class="flex-1">
              <div
                class="safety-plan-header safety-plan-bg px-3 py-2"
                style="border-radius: 10px 10px 0px 0px"
              >
                <div
                  class="app-sub-heading d-flex align-items-center justify-content-between w-100 border-0"
                  style="padding: 1rem 0rem"
                >
                  <img
                    [src]="commonService.resource.image.left_arrow"
                    alt=""
                    (click)="nextSafetyPlan(-1)"
                    *ngIf="currentSafetyPlanIndex > 1"
                  />
                  <span class="d-flex w-100 justify-content-center">
                    {{
                      safetyPlanList[currentSafetyPlanIndex]["header"]
                        | translate
                    }}
                  </span>
                  <img
                    [src]="commonService.resource.image.right_arrow"
                    alt=""
                    (click)="nextSafetyPlan(1)"
                    *ngIf="currentSafetyPlanIndex < safetyPlanList.length - 1"
                  />
                </div>
                <div class="d-flex justify-content-center pb-3">
                  <div class="safety-plan-sub-content">
                    {{
                      safetyPlanList[currentSafetyPlanIndex]["content"]
                        | translate
                    }}
                  </div>
                </div>
              </div>
              <div class="col-12 p-0">
                <div class="" style="padding: 25px 25px 0px">
                  <textarea
                    name=""
                    id=""
                    [placeholder]="
                      safetyPlanList[currentSafetyPlanIndex]['example']
                        | translate
                    "
                    [(ngModel)]="
                      safetyPlanList[currentSafetyPlanIndex]['userInput']
                    "
                    style="min-height: calc(var(--vh, 1vh) - 410px)"
                  ></textarea>
                </div>
              </div>
            </div>
            <div class="modal-footer border-0 m-0" style="padding: 0px 26px">
              <div class="w-100 justify-content-between gap-3">
                <div class="row m-0 p-4 px-0">
                  <div class="col-7 p-0">
                    <button
                      mat-button
                      class="primary-button w-100 p-0"
                      (click)="saveSafetyPlan()"
                    >
                      {{ "safetyPlan.saveBtn" | translate }}
                    </button>
                  </div>
                  <div class="col-5">
                    <button
                      mat-button
                      class="secondary-button w-100 p-0"
                      (click)="cancelSafetyPlan()"
                    >
                      {{ "safetyPlan.cancelBtn" | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-2 p-0"></div>
    </div>
  </div>
</div>
